import {
  ShoppingCart,
  DollarSign,
  XCircle,
  MessageSquare,
  Star,
  AlertTriangle,
  Wallet,
  Megaphone,
  CreditCard,
  Clock,
  CheckCircle,
  Ban,
  Bell,
  Sparkles,
  Store,
  Download,
  Upload,
  AlertCircle,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export const NOTIFICATION_ICONS: Record<string, LucideIcon> = {
  // Welcome
  welcome_user: Sparkles,
  store_created: Store,

  // Purchase types
  purchase_created: ShoppingCart,
  purchase_paid: CreditCard,
  purchase_completed: CheckCircle,
  purchase_cancelled: XCircle,
  purchase_refunded: DollarSign,

  // Sale types
  sale_created: ShoppingCart,
  sale_paid: CreditCard,
  sale_completed: CheckCircle,
  sale_cancelled: XCircle,

  // Escrow
  escrow_released: DollarSign,
  escrow_cancelled: XCircle,

  // Disputes
  dispute_created: AlertTriangle,
  dispute_investigating: MessageSquare,
  dispute_resolved_buyer: CheckCircle,
  dispute_resolved_seller: CheckCircle,
  dispute_rejected: Ban,

  // Reviews
  review_created: Star,
  review_seller_reply: MessageSquare,

  // Withdrawals
  withdrawal_requested: Wallet,
  withdrawal_approved: CheckCircle,
  withdrawal_rejected: XCircle,
  withdrawal_processing: Clock,

  // Deposits
  deposit_completed: CheckCircle,
  deposit_expired: Clock,

  // Transactions
  transaction_completed: CheckCircle,
  transaction_failed: XCircle,

  // Reservations
  reservation_confirmed: CheckCircle,
  reservation_cancelled: XCircle,

  // Tickets
  ticket_in_progress: MessageSquare,
  ticket_closed: CheckCircle,

  // Archive
  archive_ready: Download,

  // Account files upload
  account_files_upload_completed: Upload,
  account_files_upload_failed: AlertCircle,

  // Penalties
  penalty_issued: AlertTriangle,

  // System
  system_announcement: Megaphone,
};

export function getNotificationIcon(type: string): LucideIcon {
  return NOTIFICATION_ICONS[type] || Bell;
}
